import { Box } from '@mui/material'
import { addManualNoticeDueDate } from 'api/services/automation/config'
import DialogWrapper from 'components/DialogWrapper'
import FormDate from 'components/FormFields/FormDate'
import LoadingButton from 'components/LoadingButton'
import { snack } from 'components/toast'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useMutation, useQueryClient } from 'react-query'

const CreateManualDueDate = ({ open, setOpen, notice, type }) => {
  const queryClient = useQueryClient()
  const { control, handleSubmit, reset } = useForm({
    defaultValues: { dueDate: null }
  })

  const { mutate, isLoading } = useMutation(addManualNoticeDueDate, {
    onSuccess: () => {
      snack.success("Due Date added")
      queryClient.invalidateQueries("e-proceeding-notice")
      reset()
      setOpen(false)
    }
  })

  useEffect(() => {
    if (open) {
      reset({ dueDate: notice?.manualDueDate })
    }
  }, [open])

  const onSubmit = async (item) => {
    mutate({
      ...item,
      type: type,
      noticeId: notice?.id
    })
  }
  return (
    <DialogWrapper open={open} setOpen={setOpen} title="Add Manual Due Date">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box mt={1}>
          <FormDate
            name="dueDate"
            required
            control={control}
            label="Manual Due Date"
          />
        </Box>
        <Box mt={1}>
          <LoadingButton
            loading={isLoading}
            disabled={isLoading}
            loadingColor='white'
            type="submit"
            title="Submit"
            color='secondary'
          />
        </Box>
      </form>
    </DialogWrapper>
  )
}

export default CreateManualDueDate